// src/utils/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({positionRef}) => {
  const { pathname } = useLocation();
  const scroller = () => {
    positionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // Scrolls to top on path change
    scroller();
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
